import styled, { css } from 'styled-components'
import theme from 'theme_'
import { Font14, Font16, Font18, H5, Secondary } from 'components/Typography'
import { CommonLinkButton } from 'components/Button'
import { WhiteBlock } from 'components/Layout'

export const NetworkStatusSubscriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.sm};
  width: 100%;
  order: 1;
`

export const NetworkStatusSubscriptionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const NetworkStatusSubscriptionHeaderTitle = styled(Secondary)`
  color: ${theme.colors.moreGrey};
`

export const NetworkStatusSubscriptionHeaderMoreButton = styled(
  CommonLinkButton
)`
  ${Font16};
  color: ${theme.colors.horizonOrange};
  text-decoration-line: underline;
  text-transform: capitalize;
`

export const NetworkStatusSubscriptionBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.base};
  width: 100%;
  @media ${theme.devices.tabletLandscape} {
    flex-direction: row;
    gap: ${theme.spacing.xs};
  }
`

const NetworkStatusSubscriptionItemBase = css`
  min-height: 140px;
  width: 100%;
`

export const NetworkStatusSubscriptionSubscribe = styled.div`
  ${NetworkStatusSubscriptionItemBase};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const NetworkStatusSubscriptionSubscribeTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.s};
`

export const NetworkStatusSubscriptionSubscribeTitle = styled(H5)`
  color: ${theme.colors.black};
`

export const NetworkStatusSubscriptionSubscribeTitleIcon = styled.img`
  width: 48px;
  height: 48px;
  color: ${theme.colors.black};
`

export const NetworkStatusSubscriptionSubscribeItem = styled(WhiteBlock)<{
  disabled?: boolean
}>`
  justify-content: space-between;
  ${NetworkStatusSubscriptionItemBase};
  background-color: ${theme.colors.lighterGrey};
  padding: ${theme.spacing.base};
  gap: ${theme.spacing.base};
  color: ${(p) => p.disabled && theme.colors.darkeyGrey};
`

export const NetworkStatusSubscriptionSubscribeIcon = styled.img`
  width: 60px;
  height: 60px;
  color: ${theme.colors.black};
`

export const NetworkStatusSubscriptionForwardIcon = styled.img`
  width: 15;
  height: 15;
  color: ${theme.colors.black};
  float: right;
`

export const NetworkStatusSubscriptionItemHeader = styled.div`
  font-weight: 900;
`

export const NetworkStatusSubscriptionItemBody = styled.div`
  float: right;
`

export const NetworkStatusSubscriptionItemFooter = styled.div`
  ${Font14};
  display: flex;
  justify-content: flex-start;
  font-weight: 900;
`

export const NetworkStatusSubscriptionItemRight = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 15px;
  flex: 1;
  ${Font14};
  color: ${theme.colors.moreGrey};
`

export const NetworkStatusSubscriptionItemLeft = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
  gap: 10px;
  width: 100%;
  ${Font14};
  color: ${theme.colors.moreGrey};
`

export const NetworkStatusSubscriptionClaimed = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
  gap: 10px;
  width: 100%;
  ${Font14};
  color: ${theme.colors.moreGrey};
`

export const NetworkStatusSubscriptionClaimedCount = styled.span`
  ${Font18};
  color: ${theme.colors.black};
  font-weight: 900;
`

export const NetworkStatusSubscriptionTotalRight = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 15px;
  flex: 1;
  ${Font18};
  color: ${theme.colors.horizonOrange};
  font-weight: 900;
`

export const NetworkStatusSubscriptionTotalLeft = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
  gap: 10px;
  width: 100%;
  ${Font18};
  color: ${theme.colors.black};
  font-weight: 900;
`

export const NetworkStatusSubscriptionForwardButton = styled(CommonLinkButton)`
  display: flex;
  justify-content: flex-end;
  float: right;
`

export const NetworkStatusSubscriptionSubCount = styled.span`
  ${Font18};
  color: ${theme.colors.green};
  font-weight: 900;
`

export const NetworkStatusSubscriptionSubCountLabel = styled.span`
  ${Font16};
  color: ${theme.colors.moreGrey};
  font-weight: 750;
`

export const SubRemainingStatus = styled.div`
  order: 2;
  @media ${theme.devices.mobile} {
    order: 0;
  }
`
